import React, {ComponentProps, ReactElement} from "react";
import {InputLabel, Select, SelectOptionProps} from "peggirkit";

type Props = {
    label: ReactElement<ComponentProps<typeof InputLabel>>,
    trueLabel: string,
    falseLabel: string,
    value: boolean,
    onChange: (value: boolean) => void,
    disabled?: boolean,
};

/**
 * A yes/no choice as a select. The select only supports strings and numbers,
 * so `false`/`true` are `0`/`1` inside it.
 */
const BooleanSelect = ({label, trueLabel, falseLabel, value, onChange, disabled = false}: Props) => {
    const options: SelectOptionProps<number>[] = [
        {value: 0, displayValue: falseLabel},
        {value: 1, displayValue: trueLabel},
    ];

    return (
        <Select<number>
            label={label}
            options={options}
            value={options.find(option => option.value === (value ? 1 : 0)) ?? null}
            displayValueEmpty={"-"}
            onChange={(option: SelectOptionProps<number>) => onChange(option.value === 1)}
            disabled={disabled}
        />
    );
};

export default BooleanSelect;